import { urlMaker } from '@shared/utils/url-maker'
import { caller } from '@shared/utils/caller'
import { ApiResponse } from '@shared/utils/api-response'
import { Department, DepartmentFormData, DepartmentFormDataApi, DepartmentFormErrors, DepartmentSelect } from '../types'
import { DepartmentMappers } from '../mappers'
import { appendToFormData } from '@shared/utils/apply-to-form-data'
import { NextTableMetaResponse } from '@shared/modules/next-table/types'
import { nextTableMetaMapper } from '@shared/modules/next-table/utils/meta-mapper'

export class DepartmentsService {
  public static async getAll(
    query?: Record<string, any>,
  ): Promise<ApiResponse<200, Department[], NextTableMetaResponse> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/departments', query)

    try {
      const response = await caller(url)

      if (response.ok) {
        const { data, ...meta } = await response.json()
        const mappedData = DepartmentMappers.manyFromApi(data)
        return new ApiResponse(200, mappedData, nextTableMetaMapper(meta.meta))
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async getSelect(query?: Record<string, any>): Promise<ApiResponse<200, DepartmentSelect[]> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/departments/select', query)

    try {
      const response = await caller(url)

      if (response.ok) {
        const result = await response.json()
        const mappedData = DepartmentMappers.manyFromSelectApi(result)
        return new ApiResponse(200, mappedData, null)
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi', null)
    }
  }

  public static async getOneById(id: string | number): Promise<ApiResponse<200, Department> | ApiResponse<400 | 500, string>> {
    const url = urlMaker('/api/departments/info', { id })
    try {
      const response = await caller(url)

      if (response.ok) {
        const { data } = await response.json()
        return new ApiResponse(200, DepartmentMappers.fromApi(data), null)
      } else {
        return new ApiResponse(400, 'Məlumatlar əldə edilə bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }

  public static async createOrUpdate(
    values: DepartmentFormData,
    type: string = 'create',
  ): Promise<ApiResponse<200> | ApiResponse<422, DepartmentFormErrors> | ApiResponse<400 | 500, string>> {
    const url = type === 'create' ? urlMaker('/api/departments/create') : urlMaker(`/api/departments/edit`)
    const body = new FormData()

    appendToFormData<DepartmentFormDataApi>(DepartmentMappers.formDataToApi(values), body)

    try {
      const response = await caller(url, { body, method: 'POST' })

      if (response.ok) {
        return new ApiResponse(200, null, null)
      } else if (response.status === 422) {
        const { errors } = await response.json()

        return new ApiResponse(422, DepartmentMappers.formErrorsFromApi(errors), null)
      } else {
        return new ApiResponse(400, 'Əməliyyat aparıla bilmədi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Şəbəkə ilə əlaqə qurula bilmədi.', null)
    }
  }

  public static async deleteById(id: string | number): Promise<ApiResponse<200, string> | ApiResponse<500, string>> {
    try {
      const url = urlMaker('/api/departments/remove')
      const body = new FormData()

      appendToFormData({ id }, body)
      const response = await caller(url, { method: 'POST', body })
      if (!response.ok) {
        return new ApiResponse(500, 'Əməliyyat aparıla bilmədi.', null)
      } else {
        return new ApiResponse(200, 'Şirkət uğurla silindi.', null)
      }
    } catch (e) {
      return new ApiResponse(500, 'Əməliyyat aparıla bilmədi.', null)
    }
  }
}
